import { addListener } from './addListener'
import { removeListener } from './removeListener'

const limitTimer = (): Promise<boolean> =>
  new Promise(resolve => {
    setTimeout(() => {
      if ((window as any)._idvu) {
        resolve(true)
      } else {
        resolve(false)
      }
    }, 100)
  })

const readyListener = (): Promise<boolean> =>
  new Promise(resolve => {
    const readyHandler = () => {
      removeListener('ready', readyHandler)
      resolve(true)
    }
    addListener('ready', readyHandler)
  })

export function ready(): Promise<boolean> {
  return Promise.race([limitTimer(), readyListener()])
}
